<template>
  <v-dialog v-model="showLocalDialog" width="800">
    <v-card width="800" class="sigfloCard">
      <product-image-carousel
        :carouselHeight="carouselHeight"
        :carouselWidth="carouselWidth"
        :product="product"
      ></product-image-carousel>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      productImageCarousel: () => import('./ProductImageCarousel.vue')
    },
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      product: {
        type: Object,
        required: true
      },
      carouselHeight: {
        type: Number,
        default: 800
      },
      carouselWidth: {
        type: Number,
        default: 100
      }
    },
    data() {
      return {
        showLocalDialog: this.showDialog
      };
    },
    watch: {
      showDialog(val) {
        this.showLocalDialog = val;
      },
      showLocalDialog(val) {
        this.$emit('close', val);
      }
    }
  };
</script>
